import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-384a1c1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scroll-top-wrapper"
}
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 스크롤할 영역이 있을 때만 렌더링 "),
    ($setup.isScrollable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "scroll-top",
            type: "button",
            disabled: $setup.isAtTop,
            onClick: $setup.onClickScrollTopBtn,
            "aria-label": "페이지 맨 위로 이동"
          }, [
            _createVNode($setup["InlineSvg"], {
              class: _normalizeClass(["icon", { disabled: $setup.isAtTop }]),
              src: require('@/assets/icons/arrow-up.svg'),
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["src", "class"])
          ], 8 /* PROPS */, _hoisted_2)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}